<p-card>
  <div class="grid">

    <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu">
      <div class="p-0 border-round-sm font-bold ">
        <p-button *ngIf="tssprtlimitedaccess == 'N'" pTooltip="Add Department" (click)="show('Add Department','')"
          styleClass="customAdd p-button-sm p-button-raised mr-1" icon="fa fa-plus"></p-button>
        <!-- <p-button *ngIf="userRole != '1'" pTooltip="Add Department" (click)="show('Add Department','')"
          styleClass="customAdd p-button-sm p-button-raised mr-4" icon="fa fa-plus"></p-button> -->
        <p-button *ngIf="userRole == '1' && tssprtlimitedaccess == 'N'" type="button" class="btn btn-primary-outline btn-sm" pTooltip="Download Excel template"
          id="complexcelformat" (click)="downloadformate=true"> Download Excel Format</p-button>
        <p-button *ngIf="userRole == '1' " type="button" class="btn btn-primary-outline btn-sm mr-4" pTooltip="Upload Departments " id="bulkexcelupload"
          (click)="openexceluploadmodal()" tooltipPosition="bottom">Upload Department Data 
        </p-button>
        <button  class="fa fa-question helpicon"   pTooltip="Help" 
          (click)="PagehelpmodalService.openhelpmodal(ref,dialogService,'Help','7')" tooltipPosition="bottom"
          aria-hidden="true"></button>
      </div>
    </div>

  </div>

  <div class="mr-0">

    <p-table #dt [value]="departmentlistarray" [rows]="rowsize" [customSort]="true"
      (sortFunction)="this.utilityservice.customSort($event)" [scrollable]="true" scrollDirection="horizontal"
      scrollHeight="{{commonScrollHeight}}"
      [globalFilterFields]="['departmentname','deptinitial','createdon','activeflag','departmentid','createdby']"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [first]="currentPageIndex"
      [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true" [showCurrentPageReport]="true"
      paginatorLocale="fa-IR" [paginator]="departmentlistarray.length>0" [sortField]="sortfield" [sortOrder]="sortorder"
      responsiveLayout="scroll" (onPage)="handlePageChange($event)" [resizableColumns]="true" columnResizeMode="expand">

      <ng-template pTemplate="caption">
        <div class="grid table-header">
          <div class="col-12 md:col-10 sm:col-12 lg:col-10">
            <span class=" p-input-icon-lft">
              <i icon="pi pi-search"></i>
              <input class="form-control" pInputText type="text" id="tablesearch"
                (input)="dt.filterGlobal($any($event.target).value , 'contains'); searchTerm = $any($event.target).value;" placeholder="Search in Department"
                class="tablesearch" pTooltip="Enter Search Criteria" tooltipPosition="top" />
            </span>
          </div>
          <div class="col-12 lg:col-2 md:col-2 sm:col-12 ">
            <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom" (click)="showDialog()"></div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 5px !important;" class="tableaction">Action</th>
          <ng-container *ngFor="let col of _selectedColumns">
            <th pResizableColumn [pSortableColumn]="col.field" *ngIf="col.isChecked">
              {{col.header}}<p-sortIcon [field]="col.field"></p-sortIcon>
              <p-columnFilter *ngIf="col.field !== 'activeflag'" type="text" [field]="col.field"
                display="menu"></p-columnFilter>

            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data>
        <tr>
          <td style="width: 5px !important;">
            <div style="display: flex; gap: 0px;">
              <span *ngIf="tssprtlimitedaccess == 'N'" class="actionItm" pTooltip="Modify" tooltipPosition="left"> <i class="fa fa-edit"
                  (click)="show('Modify Department',data)"></i></span>
              <span *ngIf="this.isSupportAdmin=='Y' && data.activeflag=='Y'" class="actionItm icon-gap"
                pTooltip="Inactivate Department" tooltipPosition="left">
                <i class="fa fa-times" style="color:red" (click)="openInactiveModal(data)"></i>
              </span>
            </div>
          </td>
          <ng-container *ngFor="let col of _selectedColumns">
            <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
            <span  *ngIf="col.field !== 'activeflag'" pTooltip=" {{data[col.field]}}"  [innerHTML]="highlight(data[col.field],searchTerm)"></span>
             <span *ngIf="col.field=='activeflag'">
                <i *ngIf="data[col.field]=== 'Y'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: green;"></i>
                <i *ngIf="data[col.field]!== 'Y'" pTooltip="Inactive" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: red;"></i>
              </span>
            </td>
            <!-- <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
              <span *ngIf="col.field!=='activeflag'" pTooltip=" {{data[col.field] }}"> {{data[col.field] }}</span>
              <span *ngIf="col.field=='activeflag'">
                <i *ngIf="data[col.field]=== 'Y'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: green;"></i>
                <i *ngIf="data[col.field]!== 'Y'" pTooltip="Inactive" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: red;"></i>
              </span>
            </td> -->
          </ng-container>
        </tr>
      </ng-template>
       <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="datanotfound">
            No data available
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
   
</p-card>







<!-- download excel formate for bulkupload -->
<p-dialog header="Download Excel Format" [(visible)]="downloadformate" [modal]="true" [baseZIndex]="10000"
  [draggable]="true" [resizable]="false" position="center" [style]="{width: '70%', height: '30%'}">
  <div class="dialog-content-min-excel" style=" text-align: center !important;">
    <div class="card">
      <p>{{templatedownloadtext}}</p>
    </div>
  </div>
  <div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="downloadformate=false"></p-button>
    <p-button class="m-1 w-full" label="Download" styleClass="customesave" (click)="excelUploadFormat()"></p-button>
  </div>
</p-dialog>

<p-dialog header="Inactivate Department" [(visible)]="inactiveModal" [modal]="true" [baseZIndex]="10000"
  [draggable]="true" [resizable]="false" position="center" [style]="{width: 'auto%', height: 'auto'}">

  <div class="p-3">
    <p *ngIf="selectedDepartmentName">
      The <strong>{{ selectedDepartmentName }}</strong> department will be inactivated upon clicking the <b>Inactivate</b>
      button. !
    </p>
  </div>

  <div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="inactiveModal=false"></p-button>
    <p-button class="m-1 w-full" label="Inactivate" styleClass="customesave"
      (click)="inactivateDepartment(departmentId)"></p-button>
  </div>
</p-dialog>

<!-- <app-bulkexcelupload></app-bulkexcelupload> -->
<!-- <p-dialog header="Bulk upload" [(visible)]="bulkModal" [modal]="true" [baseZIndex]="10000" [draggable]="true"
  [resizable]="false" position="top" [style]="{width: '100%', height: 'auto'}" (onclose)="handleDialogClose()">
  <div class="dialog-content" style=" text-align: center !important;">
    <app-bulkexcelupload (fileEmit)="getselectfiles($event)"></app-bulkexcelupload>
  </div>
  <div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="bulkModal=false"></p-button>
    <p-button class="m-1 w-full" label="Upload" styleClass="customesave" (click)="fileupload()"></p-button>
  </div>
</p-dialog> -->